import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Clock, AlertCircle } from 'lucide-react';

/** Avviso non bloccante sullo stato della prova o del pagamento. */
export const TrialBanner = () => {
  const { API, getAuthHeaders } = useAuth();
  const [sub, setSub] = useState(null);

  useEffect(() => {
    axios.get(`${API}/billing/subscription`, getAuthHeaders())
      .then(r => setSub(r.data)).catch(() => setSub(null));
  }, [API, getAuthHeaders]);

  if (!sub || !sub.needs_attention) return null;

  const expired = sub.state === 'trial_expired';
  const pastDue = sub.past_due;
  const text = pastDue
    ? 'Il rinnovo non è andato a buon fine: aggiorna la carta per non perdere le automazioni.'
    : expired
      ? 'La prova gratuita è finita. Puoi continuare a lavorare: scegli un piano quando vuoi.'
      : `Ti restano ${sub.days_left} giorni di prova gratuita.`;

  return (
    <Link to="/settings?tab=subscription" data-testid="trial-banner"
      className={`mb-4 flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
        expired || pastDue
          ? 'bg-amber-500/10 text-amber-900 dark:text-amber-200 hover:bg-amber-500/20'
          : 'bg-primary/10 hover:bg-primary/15'}`}>
      {expired || pastDue ? <AlertCircle className="w-4 h-4 shrink-0" /> : <Clock className="w-4 h-4 shrink-0" />}
      <span className="flex-1">{text}</span>
      <span className="font-medium whitespace-nowrap underline underline-offset-2">Vedi i piani</span>
    </Link>
  );
};
